import { __decorate, __metadata, __awaiter } from 'tslib';
import { Service } from '../../decorators/class/service.js';
import { StateManager } from '../store/state-manager.js';

/**
 * TransitionService，用于设置组件过渡动画
 *
 * @alpha
 */
let TransitionService = class TransitionService {
    constructor(store) {
        this.store = store;
        this.transitions = new Map();
    }
    /**
     * 注册一个动画
     * @param key - 组件动画名
     * @param transitionStyle - 动画样式
     */
    register(key, transitionStyle) {
        this.transitions.set(key, transitionStyle);
        const triggerKey = `transition.trigger.${key}`;
        if (!this.store.has(triggerKey)) {
            this.store.register(triggerKey, true);
        }
    }
    get(key) {
        var _a;
        return (_a = this.transitions.get(key)) !== null && _a !== void 0 ? _a : {
            entering: {},
            entered: {},
            exiting: {},
            exited: {},
            duration: 0,
        };
    }
    /**
     * 按顺序执行动画
     *
     * @param queue - 动画队列
     */
    apply(queue) {
        return __awaiter(this, void 0, void 0, function* () {
            const transition = queue.shift();
            if (!transition) {
                return;
            }
            const { name, switchTo, force } = transition;
            const transitionStyle = this.get(name);
            const { duration } = transitionStyle;
            const triggerKey = `transition.trigger.${name}`;
            const currentValue = this.store.getValue(triggerKey);
            if (currentValue === switchTo && !force) {
                yield this.apply(queue);
                return;
            }
            this.store.update(triggerKey, switchTo);
            yield new Promise(resolve => setTimeout(resolve, duration));
            yield this.apply(queue);
        });
    }
};
TransitionService = __decorate([
    Service(),
    __metadata("design:paramtypes", [StateManager])
], TransitionService);

export { TransitionService };
//# sourceMappingURL=transition-service.js.map
